import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Auth } from '../models/auth';
import { getADUserState } from '../reducers/auth.reducers';

/**
 * Feature selector for the auth state
 */
export const getAuthState: MemoizedSelector<object, Auth> = createFeatureSelector<Auth>('auth');
/**
 * Selector to get the AD user from the state
 */
export const getADUser: MemoizedSelector<object, adal.User> = createSelector(
  getAuthState,
  getADUserState
);
/**
 * Selector to get the AD user id from the state
 */
export const getUserId: MemoizedSelector<object, any> = createSelector(
  getADUser,
  user => user && user.profile.oid
);
